import "./App.css";
import Header from "./common/Header";
import { useLocation } from "react-router-dom";
import { Route, Routes, Navigate } from "react-router-dom";
import { Home } from "./pages/home/Home";
import { Admin } from "./pages/admin/Admin";
import { AdminSettings } from "./pages/admin-settings/AdminSettings";
import { AdminAppointments } from "./pages/admin-appointments/AdminAppointments";
import { AdminHaircuts } from "./pages/admin-haircuts/AdminHaircuts";
import { HaircutDetails } from "./pages/admin-haircuts/HaircutDetails";
import { NewHaircut } from "./pages/admin-haircuts/NewHaircut";
import { AdminVacation } from "./pages/admin-vacation/AdminVacation";
import { AdminEducationPrices } from "./pages/admin-education-prices/AdminEducationPrices";
import { AdminEducationSlots } from "./pages/admin-education-slots/AdminEducationSlots";
import { AdminEducationApplications } from "./pages/admin-education-applications/AdminEducationApplications";
import { Reservation } from "./pages/reservation/Reservation";
import { Login } from "./pages/login/Login";
import { UserLogin } from "./pages/login/UserLogin";
import { Profile } from "./pages/profile/Profile";
import { Settings } from "./pages/profile/Settings";
import { MyAppointments } from "./pages/profile/MyAppointments";
import { MyEducations } from "./pages/profile/MyEducations";
import { UserRegistration } from "./pages/login/UserRegistration";
import { ReservationResponse } from "./pages/reservation/ReservationResponse";
import AdminRoute from "./config/AdminRoute";
import ProtectedRoute from "./config/ProtectedRoute";

import { EducationsHomePage } from "./pages/educations/EducationsHomePage";

import { BeginnerEducation } from "./pages/educations/Beginner/BeginnerEducation";
import { NineWeek } from "./pages/educations/Beginner/NineWeek/NineWeek";
import { TwelveWeek } from "./pages/educations/Beginner/TwelveWeek/TwelveWeek";

import { SingleEducation } from "./pages/educations/Single/SingleEducation";
import { HandsOn } from "./pages/educations/Single/HandsOn/HandsOn";
import { LookAndLearn } from "./pages/educations/Single/LookAndLearn/LookAndLearn";
import { OneOnOne } from "./pages/educations/Single/OneOnOne/OneOnOne";

import { WorkshopEducation } from "./pages/educations/Wokrshop/WorkshopEducation";
import { CreativeFormation } from "./pages/educations/Wokrshop/CreativeFormation/CreativeFormation";
import { Fade } from "./pages/educations/Wokrshop/Fade/Fade";
import { Formation } from "./pages/educations/Wokrshop/Formation/Formation";
import { Fundamental } from "./pages/educations/Wokrshop/Fundamental/Fundamental";

import { OnlineEducation } from "./pages/educations/Online/OnlineEducation";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import { EducationConfirmation } from "./pages/EducationConfirmation";

function App() {
    const location = useLocation();

    // Show header only when route contains "educations"
    const showHeader = location.pathname.includes("/educations");

    return (
        <>
            {showHeader && <Header />}
            <div>
                <Routes>
                    <Route path='/' element={<Home />} />
                    <Route path='/login' element={<Login />} />
                    <Route path='/user-login' element={<UserLogin />} />
                    <Route
                        path='/admin'
                        element={
                            <AdminRoute>
                                <Admin />
                            </AdminRoute>
                        }
                    />
                    <Route
                        path='/admin-appointments'
                        element={
                            <AdminRoute>
                                <AdminAppointments />
                            </AdminRoute>
                        }
                    />
                    <Route
                        path='/admin-settings'
                        element={
                            <AdminRoute>
                                <AdminSettings />
                            </AdminRoute>
                        }
                    />
                    <Route
                        path='/admin-haircuts/:id'
                        element={
                            <AdminRoute>
                                <HaircutDetails />
                            </AdminRoute>
                        }
                    />
                    <Route
                        path='/admin-haircuts'
                        element={
                            <AdminRoute>
                                <AdminHaircuts />
                            </AdminRoute>
                        }
                    />
                    <Route
                        path='/admin-haircuts/new'
                        element={
                            <AdminRoute>
                                <NewHaircut />
                            </AdminRoute>
                        }
                    />
                    <Route
                        path='/admin-vacation'
                        element={
                            <AdminRoute>
                                <AdminVacation />
                            </AdminRoute>
                        }
                    />
                    <Route
                        path='/admin-education-prices'
                        element={
                            <AdminRoute>
                                <AdminEducationPrices />
                            </AdminRoute>
                        }
                    />
                    <Route
                        path='/admin-education-slots'
                        element={
                            <AdminRoute>
                                <AdminEducationSlots />
                            </AdminRoute>
                        }
                    />
                    <Route
                        path='/admin-education-applications'
                        element={
                            <AdminRoute>
                                <AdminEducationApplications />
                            </AdminRoute>
                        }
                    />
                    <Route
                        path='/profile'
                        element={
                            <ProtectedRoute>
                                <Profile />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path='/my-appointments'
                        element={
                            <ProtectedRoute>
                                <MyAppointments />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path='/my-educations'
                        element={
                            <ProtectedRoute>
                                <MyEducations />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path='/settings'
                        element={
                            <ProtectedRoute>
                                <Settings />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path='/registration'
                        element={<UserRegistration />}
                    />
                    <Route path='/reservation' element={<Reservation />} />
                    <Route
                        path='/reservation-response'
                        element={<ReservationResponse />}
                    />
                    <Route
                        path='/educations'
                        element={<EducationsHomePage />}
                    />
                    <Route
                        path='/educations/workshop'
                        element={<WorkshopEducation />}
                    />
                    <Route
                        path='/educations/workshop/fundamental'
                        element={<Fundamental />}
                    />
                    <Route
                        path='/educations/workshop/formation'
                        element={<Formation />}
                    />
                    <Route
                        path='/educations/workshop/creative-formation'
                        element={<CreativeFormation />}
                    />
                    <Route
                        path='/educations/workshop/fade'
                        element={<Fade />}
                    />
                    <Route
                        path='/educations/single'
                        element={<SingleEducation />}
                    />
                    <Route
                        path='/educations/single/hands-on'
                        element={<HandsOn />}
                    />{" "}
                    <Route
                        path='/educations/single/look-and-learn'
                        element={<LookAndLearn />}
                    />
                    <Route
                        path='/educations/single/one-on-one'
                        element={<OneOnOne />}
                    />
                    <Route
                        path='/educations/beginner'
                        element={<BeginnerEducation />}
                    />
                    <Route
                        path='/educations/beginner/nine-week'
                        element={<NineWeek />}
                    />
                    <Route
                        path='/educations/beginner/twelve-week'
                        element={<TwelveWeek />}
                    />
                    <Route
                        path='/educations/online'
                        element={<OnlineEducation />}
                    />
                    <Route path='/educations/cart' element={<CartPage />} />
                    <Route
                        path='/educations/checkout'
                        element={<CheckoutPage />}
                    />
                    <Route
                        path='/education-confirmation'
                        element={<EducationConfirmation />}
                    />
                    <Route path='*' element={<Navigate to='/' replace />} />
                </Routes>
            </div>
        </>
    );
}

export default App;
